export const PaymentProvider = Object.freeze({
  Simple: 1,
  Barion: 2,
  Cmfx: 3,
  Szamlazz: 4,
  Szep: 5,
});
